import React, { useState, useRef, useEffect } from "react";
import "../Booking/ManageBooking.css";
import { Link } from "react-router-dom";
import { Button } from "@mui/material";
import client from "../../../Common/Client/Client";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { toast } from "react-hot-toast";

const DateWiseBooking = () => {
  const today = new Date().toLocaleDateString("en-In");
  const [selectedDate, setSelectedDate] = useState(today);
  const [bookedTicket, setBookedTicket] = useState([]);
  const [open, setOpen] = useState(false);
  const [booking, setBooking] = useState([]);
  const [loading, setLoading] = useState(false);
  const [count, setCount] = useState(0);
  const [page, setPage] = useState(1);

  const dateRef = useRef(today);
  //   //console.log(dateRef.current);

  //   //console.log(selectedDate);

  const handleDateFilter = async () => {
    try {
      const dateFilterResponse = await client.get(
        "/booking/get-date-wise-booking",
        { params: { selectedDate, page }, withCredentials: true }
      );

      //console.log(dateFilterResponse.data.dateWiseBooking);

      if (dateFilterResponse.status === 200) {
        setBookedTicket(dateFilterResponse.data.dateWiseBooking);
        setOpen(true);
        setCount(dateFilterResponse.data.count);
      }
    } catch (error) {
      //console.log(error);
    }
  };

  const handlePag = (pagenum) => {
    setPage(pagenum);
  };

  useEffect(() => {
    handleDateFilter();
  }, [page]);

  const handleDownload = () => {
    if (
      !bookedTicket[0]?.pagination ||
      bookedTicket[0]?.pagination.length === 0
    ) {
      toast.error("No booking data available to download.");
      return;
    }

    // Map data for Excel
    const data = bookedTicket[0]?.unpagination.map((item, index) => ({
      "S.no": index + 1,
      Name: item?.details?.bookings?.name,
      "Seat No": item?.details?.bookings?.number,
      "Departure Date": item?._id,
      "Booked Date": new Date(selectedDate).toLocaleDateString("en-IN"),
      Age: item?.details?.bookings?.age,
      Gender: item?.details?.bookings?.gender,
      "Age Group": item?.details?.bookings?.agegroup,
      "Mobile Number": item?.details?.bookings?.mobileNumber,
      PNR: item?.details?.bookings?.PNR,
      Price: item?.details?.bookings?.price,
    }));

    // Create worksheet and workbook
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Booking Data");

    // Export to file
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const fileData = new Blob([excelBuffer], {
      type: "application/octet-stream",
    });
    saveAs(
      fileData,
      `dateWiseDeparture-${new Date(selectedDate).toLocaleDateString()}.xlsx`
    );
  };

  return (
    <>
      <main id="main" className="main">
        <div className="pagetitle">
          <nav>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/">Home</Link>
              </li>
              <li className="breadcrumb-item active">Manage Booking Details</li>
            </ol>
          </nav>
        </div>
        <section
          className="section dashboard"
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "70px",
          }}
        >
          <div className="card" style={{ width: "100%" }}>
            <div className="card-body" style={{ padding: "20px" }}>
              <h5
                className="card-title"
                style={{ textAlign: "center", marginBottom: "20px" }}
              >
                Date Wise Booking Details
              </h5>
              <div className="booking-package package-facilities-section">
                <p>Select the Date for view Booking</p>
                <div className="date-booking">
                  <div>
                    <input
                      type="date"
                      value={selectedDate}
                      //   ref={dateRef.current}
                      onChange={(e) => {
                        setSelectedDate(e.target.value);
                        setOpen(false);
                        setBookedTicket([]);
                      }}
                      className="form-control"
                      style={{
                        padding: "10px",
                        borderRadius: "8px",
                        border: "1px solid #ccc",
                      }}
                    />
                  </div>
                  <div>
                    <Button
                      variant="contained"
                      className=""
                      onClick={handleDateFilter}
                      disabled={open}
                      style={{
                        backgroundColor: "#e89e25 ",
                      }}
                    >
                      submit
                    </Button>
                  </div>
                </div>
                {open && (
                  <div className="booking-table" style={{ marginTop: "30px" }}>
                    {bookedTicket?.[0].unpagination.length === 0 ? (
                      <p>No bookings found for the selected date.</p>
                    ) : (
                      <div>
                        <div className="shown-details">
                          <div>
                            <p>
                              Total Amount:₹
                              {bookedTicket[0]?.totalAmount[0]?.amount}
                            </p>
                          </div>
                          <div>
                            <Button
                              variant="contained"
                              onClick={handleDownload}
                              style={{
                                backgroundColor: "green ",
                              }}
                            >
                              Download in Excel
                            </Button>
                          </div>
                        </div>
                        <div className="table-responsive px-2 mt-2">
                          <table className="table table-striped table-hover table-bordered ">
                            <thead>
                              <tr>
                                <th>S.no</th>
                                <th>Departure Date</th>
                                <th>Name</th>
                                <th>Seat No</th>
                                <th>Age</th>
                                <th>Gender</th>
                                <th>Age Group</th>
                                <th>Mobile</th>
                                <th>Proof</th>
                                <th>Proof ID</th>
                                <th>PNR</th>
                                <th>Price</th>
                              </tr>
                            </thead>
                            {}
                            <tbody>
                              {bookedTicket &&
                                bookedTicket[0]?.pagination.map(
                                  (item, index) => {
                                    return (
                                      <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{item?._id}</td>
                                        <td>{item?.details?.bookings?.name}</td>
                                        <td>
                                          {item?.details?.bookings?.number}
                                        </td>
                                        <td>{item?.details?.bookings?.age}</td>
                                        <td>
                                          {item?.details?.bookings?.gender}
                                        </td>
                                        <td>
                                          {item?.details?.bookings?.agegroup}
                                        </td>
                                        <td>
                                          {
                                            item?.details?.bookings
                                              ?.mobileNumber
                                          }
                                        </td>
                                        <td>
                                          {item?.details?.bookings?.proof}
                                        </td>
                                        <td>
                                          {
                                            item?.details?.bookings
                                              ?.proofIdNumber
                                          }
                                        </td>
                                        <td>{item?.details?.bookings?.PNR}</td>
                                        <td>
                                          ₹{item?.details?.bookings?.price}
                                        </td>
                                        {/* <td>{dateTime(item.cancelTime)}</td> */}
                                      </tr>
                                    );
                                  }
                                )}
                            </tbody>
                          </table>
                          <nav
                            aria-label="Page navigation example"
                            style={{ marginTop: "15px" }}
                          >
                            <ul className="pagination justify-content-center">
                              <li className="page-item">
                                <button
                                  className="page-link"
                                  tabIndex="-1"
                                  onClick={() => handlePag(page - 1)}
                                  disabled={page === 1}
                                >
                                  Previous
                                </button>
                              </li>

                              {count > 0 &&
                                Array.from({
                                  length: Math.ceil(count / 10),
                                }).map((_, i) => {
                                  const totalPages = Math.ceil(count / 10);

                                  if (i < 2 || i >= totalPages - 2) {
                                    return (
                                      <li className="page-item" key={i}>
                                        <button
                                          className="page-link"
                                          onClick={() => handlePag(i + 1)}
                                        >
                                          {i + 1}
                                        </button>
                                      </li>
                                    );
                                  }

                                  if (i === 2 && totalPages > 4) {
                                    return (
                                      <li
                                        key="dots"
                                        className="page-item disabled"
                                      >
                                        <span className="page-link">...</span>
                                      </li>
                                    );
                                  }

                                  return null;
                                })}

                              <li className="page-item">
                                <button
                                  className="page-link"
                                  onClick={() => handlePag(page + 1)}
                                  disabled={page === count}
                                >
                                  Next
                                </button>
                              </li>
                            </ul>
                          </nav>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
};

export default DateWiseBooking;
